class WindowHelper {
    static getWindowLocation = (): Location => {
        return window.location;
    };

    static setWindowLocation = (location: string) => {
        if(window.location.pathname !== location) {
            window.location.assign(location);
            return;
        }
    };

    static isElementInViewport = (el: any): boolean => {
        const rect     = el.getBoundingClientRect(),
            vWidth   = window.innerWidth,
            vHeight  = window.innerHeight,
            efp = (x: number, y: number) => document.elementFromPoint(x, y);

        // Return false if it's not in the viewport
        if (rect.right < 0 || rect.bottom < 0
                || rect.left > vWidth || rect.top > vHeight)
            return false;

        // Return true if any of its four corners are visible
        return (
              el.contains(efp(rect.left,  rect.top))
          ||  el.contains(efp(rect.right, rect.top))
          ||  el.contains(efp(rect.right, rect.bottom))
          ||  el.contains(efp(rect.left,  rect.bottom))
        );
    };

    static getItemFromLocalStorage = (key: string, useJson: boolean = true) : any => {
        const item = window.localStorage.getItem(key);
        if(useJson) {
            return item ? JSON.parse(item) : null;
        }
        return item;
    };

    static saveItemToLocalStorage = (key: string, value: any): void => {
        window.localStorage.setItem(key, JSON.stringify(value));
    };

    static removeItemFromLocalStorage = (key: string): void => {
        window.localStorage.removeItem(key);
    };
}

export default WindowHelper;
